const SHOW_MENU = true
const HIDE_MENU = false

const navigator = {
  state: {
    isShow: false,
    detail: {
      title: '',
      content: []
    }
  },
  mutations: {
    showNavigator (state, obj) {
      state.detail = obj === undefined ? state.detail : obj.amount
      state.isShow = SHOW_MENU
    },
    hideNavigator (state) {
      state.detail = {}
      state.isShow = HIDE_MENU
    }
  },
  actions: {
    showNavigator ({commit}, obj) {
      commit('showNavigator', obj)
    },
    hideNavigator ({commit}) {
      commit('hideNavigator')
    }
  },
  getters: {
    getNavigatorIsShow: state => state.isShow,
    getNavigatorMenuInfo: state => state.detail
  }
}
export default navigator



// WEBPACK FOOTER //
// ./src/store/modules/navigator.js